export default "/images/8a0a861ae2aaff02822d144e7c6670ce.avif";